export function storeWithExpiry(key, value, ttl) {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function storeWithoutExpiry(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getWithoutExpiry(key) {
  const itemStr = localStorage.getItem(key);
  try {
    return JSON.parse(itemStr);
  } catch (e) {
    return itemStr;
  }
}
export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr && itemStr !== "undefined") {
    return {};
  }
  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return {};
  }

  return item.value;
};
